export const getContrastColor = (color: string) => {
  let r, g, b;
  if (color.startsWith('rgba')) {
    // If the color is in RGB format
    const regex =
      /rgba\((?<r>\d+),\s*(?<g>\d+),\s*(?<b>\d+),\s*(?<a>[0-9.]+)\)/;
    const rgba = regex.exec(color)!.groups as Record<
      'r' | 'g' | 'b' | 'a',
      string
    >;
    r = Number(rgba.r);
    g = Number(rgba.g);
    b = Number(rgba.b);
  } else {
    // If the color is in HEX format
    // Convert the HEX color to RGB values
    const hex = color.replace(/^#/, '');
    const scale = hex.length === 3 ? 1 : 2; // Handle #RGB and #RRGGBB
    const extractHex = (start: number) =>
      parseInt(
        hex.substr(start * scale, scale).repeat(scale === 1 ? 2 : 1),
        16,
      );
    r = extractHex(0);
    g = extractHex(1);
    b = extractHex(2);
  }
  // Calculate the perceived brightness of the color using the HSP formula
  const hsp = Math.sqrt(0.299 * r ** 2 + 0.587 * g ** 2 + 0.114 * b ** 2);
  // Determine the text color based on the perceived brightness
  return hsp > 127.5 ? '#3c4257' : 'white'; // Threshold was changed from 200 to 127.5 for better midpoint
};
